module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-评论.6fdc4.png";